class LineAttachmentsComposite {
  constructor() {
    this.children = [];
  }

  add(component) {
    this.children.push(component);
  }

  execute() {
    this.children.forEach(child => child.execute());
  }
}

export default LineAttachmentsComposite
